var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGrullPurpuleMobileLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 48,
    viewBox: "0 0 37 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.6752 -9.59076e-09L24.6752 22.0653L19.5304 22.0653L19.5304 6.92206L17.1316 6.92206L17.1316 40.5986L19.5304 40.5986L19.5304 25.3132L24.6752 25.3132L24.6752 47.5206L22.3668 47.5206L19.5455 44.4757L17.1919 47.5206L12.002 47.5206L12.002 5.21692C12.002 2.33442 13.737 -1.31302e-09 15.8794 -2.93432e-09L24.6752 -9.59076e-09Z",
    fill: "#B27EE3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.002 9.73828L28.002 38.543L36.2697 24.1305L28.002 9.73828Z",
    fill: "#B27EE3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.26758 38.543V9.73828L-0.000189781 24.1508L8.26758 38.543Z",
    fill: "#B27EE3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrullPurpuleMobileLogo);
export default __webpack_public_path__ + "static/media/grullPurpuleMobileLogo.4304df9b662d8373c8ef2faf8d986c73.svg";
export { ForwardRef as ReactComponent };